import { Carousel_Button_default } from "./chunk-FTSMOXGY.js";
import { CarouselContext } from "./chunk-6DBLI5VB.js";
import { use_resize_observer_default } from "./chunk-RKGQENCW.js";
import { scrollTo } from "./chunk-KROBAS26.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Carousel/Carousel.tsx
import React, { forwardRef, useCallback, useMemo, useState } from "react";
import clsx from "clsx";
var Carousel = forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      className,
      prevButton = /* @__PURE__ */React.createElement(Carousel_Button_default, {
        variant: "prev",
        screenReaderLabel: "Previous"
      }),
      nextButton = /* @__PURE__ */React.createElement(Carousel_Button_default, {
        variant: "next",
        screenReaderLabel: "Next"
      })
    } = _b,
    rest = __objRest(_b, ["children", "className", "prevButton", "nextButton"]);
  const [isScrollable, setIsScrollable] = useState(false);
  const scrollRef = use_resize_observer_default(refElement => {
    if (refElement) {
      setIsScrollable(refElement.scrollWidth > refElement.clientWidth);
    }
  }, 200, [children]);
  const onPrevClick = useCallback(() => {
    if (scrollRef.current) {
      scrollTo(scrollRef.current, {
        left: scrollRef.current.scrollLeft - scrollRef.current.clientWidth / 2,
        behavior: "smooth"
      });
    }
  }, []);
  const onNextClick = useCallback(() => {
    if (scrollRef.current) {
      scrollTo(scrollRef.current, {
        left: scrollRef.current.scrollLeft + scrollRef.current.clientWidth / 2,
        behavior: "smooth"
      });
    }
  }, []);
  const context = useMemo(() => ({
    onPrevClick,
    onNextClick
  }), [onPrevClick, onNextClick]);
  return /* @__PURE__ */React.createElement(CarouselContext.Provider, {
    value: context
  }, /* @__PURE__ */React.createElement("figure", __spreadValues({
    ref,
    className: clsx("pd-carousel", className)
  }, rest), /* @__PURE__ */React.createElement("ol", {
    className: "pd-carousel__list",
    ref: scrollRef
  }, typeof children === "function" ? children({
    scrollRef
  }) : children), isScrollable && /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("div", {
    className: "pd-carousel__button pd-carousel__button--prev"
  }, prevButton), /* @__PURE__ */React.createElement("div", {
    className: "pd-carousel__button pd-carousel__button--next"
  }, nextButton))));
});
var Carousel_default = Carousel;
export { Carousel_default };